import { useBoolean } from "@chakra-ui/react";
import { createContext, useEffect, useState } from "react";
import { IconType } from "react-icons";

export type Favourite = {
  name: string;
  url: string;
};

export type FavouritesState = {
  favourites: Favourite[];
  addFavourite: (favourite: Favourite) => void;
  removeFavourite: (url: string) => void;
};

export const FavouritesContext = createContext<FavouritesState>({
  favourites: [],
  addFavourite: () => null,
  removeFavourite: () => null,
} as FavouritesState);

type Props = {
  children: React.ReactNode;
};

export const FavouritesProvider = ({ children }: Props) => {
  const [favourites, setFavourites] = useState<Favourite[]>([]);
  const [loaded, setLoaded] = useBoolean();

  useEffect(() => {
    const favourites = localStorage.getItem("lighthouse-favourites");
    if (favourites) {
      setFavourites(JSON.parse(favourites));
    }
    setLoaded.on();
  }, []);

  useEffect(() => {
    if (loaded)
      localStorage.setItem("lighthouse-favourites", JSON.stringify(favourites));
  }, [favourites]);

  const addFavourite = (favourite: Favourite) => {
    setFavourites([...favourites, favourite]);
  };

  const removeFavourite = (url: string) => {
    setFavourites(favourites.filter((f) => f.url !== url));
  };

  return (
    <FavouritesContext.Provider
      value={{ favourites, addFavourite, removeFavourite }}
    >
      {children}
    </FavouritesContext.Provider>
  );
};
